export const onboardingUrl = process.env.REACT_APP_ONBOARDING_ENDPOINT;
